import { render, staticRenderFns } from "./facultiesTimetableDownload.vue?vue&type=template&id=26590f55"
import script from "./facultiesTimetableDownload.vue?vue&type=script&lang=js"
export * from "./facultiesTimetableDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports